module.exports = __webpack_public_path__ + "static/media/U-M_Logo.2f23d646.png";